import { Modal, Button } from '@/shared/components/ui';
import { AlertTriangle } from 'lucide-react';
import styles from './ModalAdvertenciaInactividad.module.css';

interface ModalAdvertenciaInactividadProps {
    /** Si el modal está abierto */
    abierto: boolean;
    /** Segundos restantes hasta logout */
    cuentaRegresiva: number;
    /** Callback para continuar sesión */
    alContinuarSesion: () => void;
}

/**
 * Modal de advertencia de inactividad
 * 
 * Aparece 10 segundos antes del logout automático por inactividad
 * El usuario puede cancelar con click botón o cualquier actividad (mouse/teclado)
 * 
 * Patrón idéntico a SessionWarningModal pero para inactividad
 */
export const ModalAdvertenciaInactividad = ({
    abierto,
    cuentaRegresiva,
    alContinuarSesion,
}: ModalAdvertenciaInactividadProps) => {
    return (
        <Modal
            isOpen={abierto}
            onClose={alContinuarSesion}
            size="md"
            closeOnOverlayClick={false}
        >
            <div className={styles.modalContent}>
                {/* Ícono */}
                <div className={styles.iconWrapper}>
                    <AlertTriangle className={styles.warningIcon} size={48} />
                </div>

                {/* Título */}
                <h2 className={styles.title}>Sesión por Inactividad</h2>

                {/* Descripción */}
                <p className={styles.description}>
                    Tu sesión se cerrará automáticamente debido a inactividad.
                </p>

                {/* Countdown Warning (patrón SessionWarningModal) */}
                <div className={styles.countdownWarning}>
                    <span className={styles.countdownText}>
                        Se cerrará sesión automáticamente en <strong className={styles.countdownNumber}>{cuentaRegresiva}</strong> segundo{cuentaRegresiva !== 1 ? 's' : ''}
                    </span>
                </div>

                {/* Acciones */}
                <div className={styles.actions}>
                    <Button
                        variant="primary"
                        onClick={alContinuarSesion}
                        className={styles.continueButton}
                        autoFocus
                    >
                        Continuar Sesión
                    </Button>
                </div>
            </div>
        </Modal>
    );
};
